import type { ReactNode } from 'react';

type DesktopThreeColumnLayoutProps = {
  left: ReactNode;
  children: ReactNode;
  right: ReactNode;
  className?: string;
};

export function DesktopThreeColumnLayout({ left, children, right, className = '' }: DesktopThreeColumnLayoutProps) {
  return (
    <main className={`desktop-three-column-shell ${className}`.trim()}>
      <aside className="desktop-three-column-shell__side desktop-three-column-shell__side--left">
        {left}
      </aside>
      <section className="desktop-three-column-shell__main">
        {children}
      </section>
      <aside className="desktop-three-column-shell__side desktop-three-column-shell__side--right">
        {right}
      </aside>
    </main>
  );
}
